export const enValidationTranslation = {
  required: "This input is required",
  email: "Invalid Email Address",
  url: "Invalid URL",
  min: "Value can not be lower than :min",
  max: "Value can not be greater than :max",
  match: "This input is not matching with :matchingInput",
  length: "This input should have :length characters",
  minLength: "This input can not be less than :length characters",
  maxLength: "This input can not be greater than :length characters",
  pattern: "This input is not matching with the :pattern",
  number: "This input accepts only numbers",
  integer: "This input accepts only integer digits",
  float: "This input accepts only integer or float digits",
  alphabet: "This input accepts only alphabets",
};

export const arValidationTranslation = {
  required: "هذا الحقل مطلوب",
  email: "بريد الكتروني خاطئ",
  url: "رابط غير صحيح",
  min: "القيمة يجب أن لا تقل عن :min",
  max: "القيمة يجب أن لا تزيد عن :max",
  match: "هذا الحقل غير متطابق مع :matchingInput",
  length: "حروف الحقل يجب ان تساوي :length",
  minLength: "هذا الحقل يجب ألا يقل عن :length حرف",
  maxLength: "هذا الحقل يجب ألا يزيد عن :length حرف",
  pattern: "هذا الحقل غير مطابق :pattern",
  number: "هذا الحقل لا يقبل غير أرقام فقط",
  integer: "هذا الحقل لا يقبل غير أرقام صحيحة",
  float: "هذا الحقل لا يقبل غير أرقام صحيحة او عشرية",
  alphabet: "هذا الحقل لا يقبل غير أحرف فقط",
};

export const frValidationTranslation = {
  required: "Ce champ est requis",
  email: "Adresse e-mail invalide",
  url: "URL invalide",
  min: "La valeur ne peut pas être inférieure à :min",
  max: "La valeur ne peut pas être supérieure à :max",
  match: "Ce champ ne correspond pas à :matchingInput",
  length: "Ce champ doit avoir :length caractères",
  minLength: "Ce champ ne peut pas être inférieur à :length caractères",
  maxLength: "Ce champ ne peut pas être supérieur à :length caractères",
  pattern: "Ce champ ne correspond pas au :pattern",
  number: "Ce champ ne peut contenir que des chiffres",
  integer: "Ce champ ne peut contenir que des chiffres entiers",
  float: "Ce champ ne peut contenir que des chiffres entiers ou décimaux",
  alphabet: "Ce champ ne peut contenir que des lettres",
};

export const esValidationTranslation = {
  required: "Este campo es obligatorio",
  email: "Dirección de correo electrónico no válida",
  url: "URL no válida",
  min: "El valor no puede ser inferior a :min",
  max: "El valor no puede ser superior a :max",
  match: "Este campo no coincide con :matchingInput",
  length: "Este campo debe tener :length caracteres",
  minLength: "Este campo no puede ser inferior a :length caracteres",
  maxLength: "Este campo no puede ser superior a :length caracteres",
  pattern: "Este campo no coincide con el :pattern",
  number: "Este campo solo acepta números",
  integer: "Este campo solo acepta dígitos enteros",
  float: "Este campo solo acepta dígitos enteros o decimales",
  alphabet: "Este campo solo acepta letras",
};

export const itValidationTranslation = {
  required: "Questo campo è obbligatorio",
  email: "Indirizzo email non valido",
  url: "URL non valido",
  min: "Il valore non può essere inferiore a :min",
  max: "Il valore non può essere superiore a :max",
  match: "Questo campo non corrisponde a :matchingInput",
  length: "Questo campo deve avere :length caratteri",
  minLength: "Questo campo non può essere inferiore a :length caratteri",
  maxLength: "Questo campo non può essere superiore a :length caratteri",
  pattern: "Questo campo non corrisponde al :pattern",
  number: "Questo campo accetta solo numeri",
  integer: "Questo campo accetta solo cifre intere",
  float: "Questo campo accetta solo cifre intere o decimali",
  alphabet: "Questo campo accetta solo lettere",
};

export const deValidationTranslation = {
  required: "Dieses Feld ist erforderlich",
  email: "Ungültige E-Mail-Adresse",
  url: "Ungültige URL",
  min: "Der Wert darf nicht kleiner sein als :min",
  max: "Der Wert darf nicht größer sein als :max",
  match: "Dieses Feld stimmt nicht mit :matchingInput überein",
  length: "Dieses Feld sollte :length Zeichen haben",
  minLength: "Dieses Feld darf nicht weniger als :length Zeichen haben",
  maxLength: "Dieses Feld darf nicht mehr als :length Zeichen haben",
  pattern: "Dieses Feld stimmt nicht mit dem :pattern überein",
  number: "Dieses Feld akzeptiert nur Zahlen",
  integer: "Dieses Feld akzeptiert nur ganze Zahlen",
  float: "Dieses Feld akzeptiert nur ganze oder Dezimalzahlen",
  alphabet: "Dieses Feld akzeptiert nur Buchstaben",
};
